// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"832d8703","488":"a1ba95eb","796":"808f97f1"}[chunkId] + ".chunk.js";
};